import { render, staticRenderFns } from "./Values.vue?vue&type=template&id=a4545858&scoped=true"
import script from "./Values.vue?vue&type=script&lang=js"
export * from "./Values.vue?vue&type=script&lang=js"
import style0 from "./Values.vue?vue&type=style&index=0&id=a4545858&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4545858",
  null
  
)

export default component.exports